import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { QueryBuilderLocalizationService } from 'src/app/shared/query-builder/query-builder-localization.service';

/**
 * Angular executes an impure pipe during every component change detection cycle.
 * An impure pipe is called often, as often as every keystroke or mouse-move.
 */
@Pipe({ name: 'ruleNarrative', pure: false })
export class RuleNarrativePipe implements PipeTransform
{

  constructor(
    private sanitized: DomSanitizer,
    private localService: QueryBuilderLocalizationService)
  {
  }

  public transform(items: any[], args?: any): SafeHtml
  {
    let narrative = '';
    let first = true;
    for (let x = 0; x < items.length; x++)
    {
      if (items[x].rules && items[x].rules.length > 0)
      {
        if (first) { first = false; } else
        {
          narrative += `${this.localService.And()} `;
        }
        narrative += `${this.localService.When()} <span class="narrative-text">` + items[x].section;
        if (items[x].subSection)
        {
          narrative += ' ' + items[x].subSection;
        }
        narrative += '</span></br>';
      }
      narrative += this.generateNarrative(items[x].rules, args[x], items[x].condition, 2, false);
    }
    return this.sanitized.bypassSecurityTrustHtml(narrative);
  }

  private generateNarrative(ruleList, config, operator, depth, prependAnd)
  {
    let narrative = '';
    for (let ruleCount = 0; ruleCount < ruleList.length; ruleCount++)
    {
      const rule = ruleList[ruleCount];
      if (rule.rules && rule.rules.length > 0)
      {
        // recurse!
        narrative += this.generateNarrative(rule.rules, config, rule.condition, depth += 1, true);
        depth -= 1;
      } else
      {
        narrative += Array(depth).join('      ');
        if (prependAnd)
        {
          prependAnd = false;
          /*2021-02-17 PR: Do not prepend anymore.
          // narrative += `${this.localService.And().toLowerCase()} `;*/
        }

        if (rule.value === undefined) { rule.value = ''; } // avoid displaying 'undefined' when building a rule.

        const conf = this.parseConfig(config, rule);
        narrative += '<span class="narrative-text">' + conf.name + '</span> ';
        narrative += this.localService.getOperatorText(rule.operator);
        narrative += ' <span class="narrative-text">' + conf.display + '</span> ';

        // don't show the and/or operator for the last rule at this level
        if (this.showOperator(ruleCount, ruleList))
        {
          narrative += operator + '</br>';
        } else
        {
          narrative += '</br>';
        }
      }
    }
    return narrative;
  }

  private showOperator(ruleCount, ruleList): boolean
  {
    if (ruleList.length > ruleCount + 1)
    { // if we have more rules ahead
      const rule = ruleList[ruleCount + 1];
      if (rule.rules && rule.rules.length > 0)
      {
        /*2021-02-17 PR: Original code
        return false; // an 'and' will precede the following line, so don't add one*/
        /*2021-02-17 PR: Since we don't prepend anymore we show and/or at the end*/
        return true;
      }
    }
    if (ruleList.length === ruleCount + 1)
    {
      return false;
    }
    return true;
  }

  private parseConfig(config: any, rule: any)
  {
    // gets display value based on what type this is.  (select box, etc.)
    let display = rule.value;
    if (config.fields[rule.field].type === 'Category')
    {
      let valuesArray = [];
      if (rule.value instanceof Array)
      {
        valuesArray = rule.value;
      }
      else
      {
        valuesArray.push(rule.value);
      }

      // Set the display name or names
      let displayNames = '';
      valuesArray.forEach(d =>
      {
        const displayValueFound = config.fields[rule.field].options.filter(x => x.value === d);
        if (displayValueFound.length === 1)
        {
          // For Array, options are listed on the next line
          if (rule.value instanceof Array)
          {
            displayNames += '<br/>             ';
          }
          displayNames += displayValueFound[0].name;
        }
        if (displayNames !== '')
        {
          display = displayNames;
        }
      });
    }

    const configObj: any = {};
    configObj.name = config.fields[rule.field].name;
    configObj.type = config.fields[rule.field].type;
    configObj.display = display;
    return configObj;
  }
}
